import styled from 'styled-components';
import { colors } from '../../styles';

export const BackButtonContainer = styled.button`
  display: flex;
  align-items: center;
  align-self: flex-start;
  background: none;
  border: none;
  color: ${colors.grayDark};
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  margin-bottom: 8px;

  &:hover {
    color: ${colors.blackDark};
  }
`;
